import {mergeDeep} from "../../../../utils/Helper";

export const alertReducer = (state, action) => {
  switch (action.type) {
    case "ALERT_UPDATE":
      return processAlertUpdate(state, action.alert);
    case "UPDATE_LOADING":
      return processUpdateLoading(state, action.loadings);
    case "TOGGLE_CHILD_ALERT":
      return processToggleChildAlert(state, action);
    case "CHILD_ALERT_SUCCESS":
      return processChildAlertSuccess(state, action);
    case "CHECKLIST_COINCIDENCE":
      return processChecklistFalseCoincidence(state, action.alert);
    case "CHANGE_FIELDS":
      return processChangeFields(state, action.fields);
  }
};

function processAlertUpdate(state, alert) {
  return mergeDeep({...state}, {alertEv: alert});
}

function processUpdateLoading(state, loadings) {
  return mergeDeep(
    {...state},
    {
      ui: {
        loadings
      }
    }
  );
}

function processToggleChildAlert(state, action) {
  if (action.alert) {
    return mergeDeep(
      {...state},
      {
        ui: {
          childAlert: {
            open: true,
            alert: action.alert
          }
        }
      }
    );
  }
  return mergeDeep(
    {...state},
    {
      ui: {
        childAlert: {
          open: false
        }
      }
    }
  );
}

function processChildAlertSuccess(state, action) {
  return mergeDeep(
    {...state},
    {
      ui: {
        childAlert: {
          alert: action.alert
        }
      }
    }
  );
}

function processChecklistFalseCoincidence(state, alert) {
  return mergeDeep(
    {...state},
    {
      alertEv: {
        falseCoincidenceListCheck: alert
      }
    }
  );
}

function processChangeFields(state, action) {
  return mergeDeep({...state}, {...action});
}
